// extracted by mini-css-extract-plugin
export default {"userCursor":"UserCursor_userCursor__xehJZ","cursorSvg":"UserCursor_cursorSvg__e3FI1","cursorName":"UserCursor_cursorName__swboX","hide":"UserCursor_hide__4tnfk"};